// ========================
// NODE IMPORTS
// ========================
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { FormattedMessage } from 'gatsby-plugin-intl';

// ========================
// CUSTOM IMPORTS
// ========================
import RichText from '../RichText';

import { Section, Container, SectionHeader, Faq, FaqItem } from './styles.js';

// ========================
// COMPONENT
// ========================

const FaqRelatedQuestionsSection = ({ data, themes }) => {
  if (!data) return null;

  const { faqItems } = data;

  const [hideFaq, setHideFaq] = useState('');

  // Get page URL and match to pageSlug to hide current FAQ from list
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const getCurrentPage = window.location.pathname;
      setHideFaq(getCurrentPage);
    }
  }, [hideFaq]);

  // ========================
  // RETURN
  // ========================
  return (
    faqItems && (
      <Section themes={themes} bg="grey" color="black">
        <Container>
          <SectionHeader faqItems={faqItems}>
            <h2>
              <FormattedMessage id="RelatedQuestions" />
            </h2>
          </SectionHeader>
          <Faq>
            {faqItems.map(({ id, pageSlug, question, faq_sub_category }) => {
              return (
                <FaqItem
                  key={id}
                  url={`/faq/${faq_sub_category[0].faq_category[0].pageSlug}/${faq_sub_category[0].pageSlug}/${pageSlug}`}
                  className={
                    hideFaq.includes(pageSlug) ? 'hide content' : 'content'
                  }
                >
                  <RichText document={question} />
                </FaqItem>
              );
            })}
          </Faq>
        </Container>
      </Section>
    )
  );
};

// ========================
// PROP TYPES
// ========================
FaqRelatedQuestionsSection.propTypes = {
  data: PropTypes.shape().isRequired,
  themes: PropTypes.string.isRequired,
};

// FaqRelatedQuestionsSection.defaultProps = {
// };

export default FaqRelatedQuestionsSection;
